<template>
	<div class="msg-detail-container">
       
        <!-- 消息详情卡片 -->
        <div class="detail-card">
            <!-- 基本信息 -->
            <div class="info-section">
                <h3 class="section-title">基本信息</h3>
                <div class="info-list">
                    <div class="info-item">
                        <span class="info-label">消息ID</span>
                        <span class="info-value">{{orderList.RecID}}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">发送日期</span>
                        <span class="info-value">{{orderList.SentTime}}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">发送人</span>
                        <span class="info-value">{{orderList.Sender}}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">当前状态</span>
                        <van-tag :type="getStatusType(orderList.Status)" class="status-tag">
                            {{orderList.Status}}
                        </van-tag>
                    </div>
                </div>
            </div>

            <!-- 消息内容 -->
            <div class="content-section">
                <h3 class="section-title">消息内容</h3>
                <div class="content-item">
                    <span class="content-label">消息主题</span>
                    <p class="content-value title-value">{{orderList.MsgTitle}}</p>
                </div>
                <div class="content-item">
                    <span class="content-label">意见内容</span>
                    <div class="message-content">
                        {{orderList.Msg}}
                    </div>
                </div>
            </div>

            <!-- 回复信息 -->
            <div class="reply-section" v-if="orderList.replymsg">
                <h3 class="section-title">回复信息</h3>
                <div class="content-item">
                    <span class="content-label">回复时间</span>
                    <p class="content-value">{{orderList.DispatchTime}}</p>
                </div>
                <div class="content-item">
                    <span class="content-label">回复内容</span>
                    <div class="reply-content">
                        {{orderList.replymsg}}
                    </div>
                </div>
            </div>

            <!-- 暂无回复 -->
            <div class="no-reply" v-else>
                <van-empty description="暂未回复" image="https://file.qingflow.com/assets/empty-content/no-data.png">
                    <p class="no-reply-text">客服正在处理中，请耐心等待</p>
                </van-empty>
            </div>
        </div>

        <!-- 返回按钮 -->
        <div class="action-section">
            <van-button type="primary" size="large" class="back-btn" to="/feedback">
                <van-icon name="arrow-left" class="btn-icon" />
                返回列表
            </van-button>
        </div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import {Dialog} from 'vant'	
	
	export default {
	  name: 'MSGINFO',	 
	  data(){
	  	return{	
            feedback: require("@/assets/icon/feedback2.png"),
            orderList:[],
            access_token:'',
			comment: require("@/assets/icon/tips.png")
        }
	  },
	  created(){				
        var that = this;
        that.$root.myTitle ='消息详情';				
        that.getData(that.$root.common.curorderid);
      },			
	  methods:{
        getStatusType(status) {
            const statusMap = {
                '待处理': 'warning',
                '已回复': 'success',
                '处理中': 'primary'
            }
            return statusMap[status] || 'default'
        },
		getData(orderid){
            var that = this;
            var myUrl = that.global.BASE_URL_T3 + '/api/login2/msginfo?msgid=' + orderid;				
            var config = {
                method: 'get',
                url: myUrl,
                headers: { 
                    'Authorization': localStorage['access_token']		
                }
            }				
            Vue.axios(config)
            .then(function (response) {
                if (response.data.Status == 0)
                {
                    that.orderList = response.data.Data[0];
                }		
                console.log(that.orderList)
            })
            .catch(function (error) {
                console.log(error);
            });
        }
	  }
	}
</script>

<style scoped>
.msg-detail-container {
    background-color: #f7f8fa;
    min-height: 100vh;
    padding-bottom: 80px;
}

.page-header {
    background: linear-gradient(135deg, #d74a43, #e87d7a);
    color: #ffffff;
    padding: 30px 20px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
}

.header-icon {
    margin-bottom: 8px;
}

.header-title {
    font-size: 18px;
    font-weight: bold;
    margin: 0;
}

.detail-card {
    background-color: #ffffff;
    margin: 16px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
    border: 1px solid #f0f0f0;
    overflow: hidden;
}

.info-section,
.content-section,
.reply-section {
    padding: 20px;
    border-bottom: 1px solid #f5f5f5;
}

.info-section:last-child,
.content-section:last-child,
.reply-section:last-child {
    border-bottom: none;
}

.section-title {
    font-size: 16px;
    font-weight: bold;
    color: #323233;
    margin-bottom: 16px;
    text-align: left;
}

.info-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.info-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0;
}

.info-label {
    font-size: 14px;
    color: #646566;
    font-weight: 500;
}

.info-value {
    font-size: 14px;
    color: #323233;
    font-weight: 500;
}

.status-tag {
    margin: 0;
}

.content-item {
    margin-bottom: 20px;
    text-align: left;
}

.content-item:last-child {
    margin-bottom: 0;
}

.content-label {
    font-size: 14px;
    color: #646566;
    font-weight: 500;
    margin-bottom: 8px;
    display: block;
    text-align: left;
}

.content-value {
    font-size: 14px;
    color: #323233;
    margin: 0;
    line-height: 1.5;
    text-align: left;
}

.title-value {
    font-weight: 500;
    color: #1989fa;
}

.message-content,
.reply-content {
    background-color: #f8f9fa;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    padding: 16px;
    font-size: 14px;
    color: #323233;
    line-height: 1.6;
    margin-top: 8px;
    text-align: left;
}

.reply-content {
    background-color: #f6ffed;
    border-color: #b7eb8f;
}

.no-reply {
    padding: 40px 20px;
    text-align: left;
}

.no-reply-text {
    font-size: 14px;
    color: #969799;
    margin-top: 8px;
    text-align: center;
}

.action-section {
    padding: 16px;
    background-color: #ffffff;
    border-top: 1px solid #f0f0f0;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
}

.back-btn {
    border-radius: 8px;
}

.btn-icon {
    margin-right: 4px;
}
</style>